module.exports = __webpack_public_path__ + "static/media/ungroup.8a62a80c.svg";